import React, { Component } from "react";

class ValidationControl extends Component {
  state = {
    data: [],
    validation: "",
    loaded: false,
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.setState({
      validations: this.props.validations,
      label: this.props.label,
      alias: this.props.alias,
      loaded: true,
    });
  }

  render() {
    if (this.state.validation) {
      return (
        <span className="text-danger d-block mb-3">
          {this.state.validation.replace(
            "{" + this.state.alias + "}",
            this.state.label
          )}
        </span>
      );
    }

    return "";
  }
}

export default ValidationControl;
